module.exports = __webpack_public_path__ + "img/mention-down.04a92f23.svg";